export default __webpack_public_path__ + "static/media/step2.77534dcb.jpg";